import React from "react";

// Says what empty means here, and what to do next. The fleet table has three
// empty cases — a failed load, no databases at all, and a search that matched
// nothing — and telling them apart is the whole point of this block.
const EmptyState = ({ icon: Icon, title, body, action }) => (
    <div className="flex flex-col items-center gap-2 bg-background-secondary px-6 py-10 text-center">
        <Icon size={20} aria-hidden="true" className="text-text-muted" />
        <div className="text-[13px] font-medium text-text-primary">{title}</div>
        <div className="text-[11px] text-text-secondary max-w-md">{body}</div>
        {action && <div className="mt-1">{action}</div>}
    </div>
);

export default EmptyState;
